//import '@mdi/font/css/materialdesignicons.css';
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import i18n from "@/i18n";
// import ru from 'vuetify/lib/locale/ru';
// import en from 'vuetify/lib/locale/en';
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";
import store from "@/store";
import { BusPlugin } from "@/plugins/bus.plugin.js";
import { UtilsPlugin } from "@/plugins/utils.plugin.js";

Vue.use(Vuetify);

const theme = {
  primary: "#00CAE3",
  secondary: "#9C27b0",
  accent: "#9C27b0",
  info: "#00CAE3",
};

const vuetify = new Vuetify({
  icons: {
    iconfont: "md", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  lang: {
    // locales: { ru, en },
    // current: 'ru',
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
});

Vue.use(VuetifyDialog, {
  context: {
    vuetify,
    store,
    i18n,
    BusPlugin,
    UtilsPlugin,
  },
  actions: {
    false: "Закрыть",
    true: {
      text: "Подтвердить",
      color: "primary",
    },
  },
});

export default vuetify;
